import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Pagination} from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../../components/Card/CustomCard";
import { toast } from 'react-toastify';

import ModalReports from '../../../components/Reportes/ModalReports';
import ReciboDePagoList from '../../../components/Reportes/ReciboDePagoList';
import { CantidadRecibos, ConsultRecibos, BuequedaReciboInd, DelRecibo } from '../../../funciones/AdministracionFunction';
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

let maxPaginas = 20;

const RecibosDePago = () => {
    const [string, setString] = useState("");
    const [icon2, setIcon2] = useState("");
    const [cantRecibos, setCantRecibos] = useState({ value: 10, label: '- Mostrar 10 Recibos -' });
    const [recibos, setRecibos] = useState([]);
    const [preloader, setPreloader] = useState(<React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando recibos</React.Fragment>);
    const [preloader2, setPreloader2] = useState("");
    const [paginas, setPaginas] = useState(0);
    const [pag, setPag] = useState(1);
    const [pagSelect, setPagSelect] = useState({ value: 1, label: '- 1 -' });
    const [openWR, setOpenWR] = useState(false);
    const [btnDel, setBtnDel] = useState({icon: "fa fa-trash", disabled: false});
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        CantidadRecibos((resp1) => {
            let pags = (resp1) / (cantRecibos.value);
            let pagis = 0;
            pagis = parseInt(pags)
            if (!pags % 1 == 0) pagis ++;
            setPaginas(pagis)
        })

        ConsultRecibos(pag, cantRecibos.value, (resp) => {
            setRecibos(resp);
            setDisabled(false);
        })
    }, []);

    useEffect(() => {
        setPagSelect({ value: 1, label: '- 1 -' })
        CantidadRecibos((resp1) => {
            let pags = (resp1) / (cantRecibos.value);
            let pagis = 0;
            pagis = parseInt(pags)
            if (!pags % 1 == 0) pagis ++;
            setPaginas(pagis)
        })

        ConsultRecibos(pag, cantRecibos.value, (resp) => {
            setRecibos(resp);
            setPreloader2("")
        })
    }, [cantRecibos]);

    useEffect(() => {
        
    }, [pagSelect]);

    let busquedaEst = () => (e) => {
        if (e.which === 13){
            if (string === "") return null
            setIcon2("fa fa-spinner fa-spin")
            BuequedaReciboInd(1, cantRecibos.value, string, (resp)=> {
                setRecibos(resp);
                setIcon2("")
            })
        }
    }

    const Recibos = [
        { value: 10, label: '- Mostrar 10 Recibos -' },
        { value: 15, label: '- Mostrar 15 Recibos -' },
        { value: 20, label: '- Mostrar 20 Recibos -' },
        { value: 30, label: '- Mostrar 30 Recibos -' },
        { value: 50, label: '- Mostrar 50 Recibos -' },
        { value: 100, label: '-  Mostrar 100 Recibos -' },
    ];

    const customStyles = {
        menu: (provided) => ({
          ...provided,
          zIndex: 10,
        })
    }

    const styles = {
        padding: 5, fontSize: 12
    }

    const styles2 = {
        padding: 5, fontSize: 10
    }

    let cambiaRecibos = (cantRecibos) => {
        setPreloader2(<i className="fa fa-spinner fa-spin"></i>)
        setCantRecibos(cantRecibos)
    }

    let cambiaPagSelect = (pagSelect) => {
        setPreloader2(<i className="fa fa-spinner fa-spin"></i>)
        setPagSelect(pagSelect)

        CantidadRecibos((resp1) => {
            let pags = (resp1) / (cantRecibos.value);
            let pagis = 0;
            pagis = parseInt(pags)
            if (!pags % 1 == 0) pagis ++;
            setPaginas(pagis)
        })

        ConsultRecibos(pagSelect.value, cantRecibos.value, (resp) => {
            setRecibos(resp);
            setPreloader2("")
        })
    }

    let items = (item, metodo) => {
        let errores = 0

        for (let i in item){
            if (item[i].status === "Error") errores++;
        }
        
        if (errores === 0){
            let contenido = []

            for (let i in item) {
                contenido.push(
                    <React.Fragment>
                        <div style= {{fontSize: 10}}>Fecha: <strong>{item[i].fecha}</strong></div>
                        <div style= {{fontSize: 10}}>Banco: <strong>{item[i].banco}</strong></div>
                        <div style= {{fontSize: 10}}>Descripción: <strong className="text-danger">{item[i].item}</strong></div>
                        {/* <div style= {{fontSize: 10}} align="right">Monto: <strong className="text-danger">{formatNumber(item[i].haber)} Bs. | {formatReconver(item[i].haber)} Bs.</strong></div> */}
                        <div style= {{fontSize: 10}} align="right">Monto: <strong className="text-danger">{formatNumber(item[i].haber)} Bs.</strong></div>
                        <div style= {{fontSize: 10}} align="right">Método de Pago: <strong className="text-danger">{metodo}</strong></div>
                        <div style={{paddingTop: 3, paddingBottom: 3}}>
                            <div style={{borderBottom: "1px solid #ccc"}}></div>
                        </div>
                    </React.Fragment>
                )
            }

            return (
                <div>{contenido}</div>
            )
        }else{
            return(
                <React.Fragment>
                    <div className="custom-alert-danger"><strong>RECIBO INVÁLIDO ***********</strong></div>
                    <div className="text-danger">Este recibo es inválido porque no pertenece a ningún estado de cuenta</div>
                </React.Fragment>
            )
        }
    }

    let totalItem = (total, item) => {
        let errores = 0

        for (let i in item){
            if (item[i].status === "Error") errores++;
        }
        
        if (errores > 0) return null

        /* return (
            <div className="custom-alert-info" align="right">Pagado: <strong className="text-danger">{formatNumber(total)} Bs. | {formatReconver(total)} Bs.</strong></div>
        ) */

        return (
            <div className="custom-alert-info" align="right">Pagado: <strong className="text-danger">{formatNumber(total)} Bs.</strong></div>
        )
    }

    let estatus = (valor) => {
        let icono = <i className="fa fa-check-circle text-success" style={{fontSize: 24}}></i>
        if (valor === "NO PROCESADO") icono = <i className="fa fa-times-circle text-danger" style={{fontSize: 24}}></i>

        return (
            <React.Fragment>
                <div algin="center" style={{paddingBottom: 10}}>{icono}</div>
                <div align = "center"><strong>{valor}</strong></div>
            </React.Fragment>
        )
    }

    let factura = (id, valor, item) => {
        let errores = 0

        for (let i in item){
            if (item[i].status === "Error") errores++;
        }

        let del = () => {
            if (btnDel.disabled === true) return null;

            setBtnDel({icon: "fa fa-spinner fa-spin", disabled: true})
            DelRecibo(id, (resp) => {
                setRecibos([])
                setBtnDel({icon: "fa fa-trash", disabled: false})

                setPreloader(<React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando recibos</React.Fragment>)
                setDisabled(true);
                toast.info(resp.mess, {autoClose: 4000});

                ConsultRecibos(pagSelect.value, cantRecibos.value, (resp) => {
                    setRecibos(resp);
                    setDisabled(false);
                    setPreloader2("")
                })
            })
        }

        switch (true){
            case (errores > 0): return (
                <button className="btn btn-relleno-danger" onClick={del} style={{borderWidth: 1}} title="Eliminar este recibo"><i className = {btnDel.icon}></i></button>
            )
            case (valor === "" || valor === null): return null;
            default: return `N° ${valor}`
        }
    }

    let detallesRecibos = () => {
        if(recibos.length === 0) return (
            <tr>
                <td align="center" colSpan={5}>{preloader}</td>
            </tr>
        )

        return (
            recibos.map(option => (
                <tr key={option.Id}>
                    <td style={styles} align="center"><strong>{option.Id}</strong></td>
                    <td style={styles2}>
                        <div style={{fontSize: 10}}><strong>{option.Ci}</strong></div>
                        <div style={{fontSize: 9}} className="text-danger"><strong>{option.Est}</strong></div>    
                    </td>
                    <td style={styles}>
                        {items(option.Detalle, option.Metodo)}
                        {totalItem(option.Total, option.Detalle)}
                    </td>
                    <td style={styles2} align="center">{estatus(option.Estatus)}</td>
                    <td style={styles} align="center"><strong className="text-danger">{factura(option.Id, option.Factura, option.Detalle)}</strong></td>
                </tr>   
            ))
        )
    }

    let cambiaPag = (pag) => (e) => {
        if (recibos === undefined) return null;
        if (recibos.length === 0) return null;
        setPag(pag)
        setPreloader2(<i className="fa fa-spinner fa-spin"></i>)
        CantidadRecibos((resp1) => {
            let pags = (resp1) / (cantRecibos.value);
            let pagis = 0;
            pagis = parseInt(pags)
            if (!pags % 1 == 0) pagis ++;
            setPaginas(pagis)
        })

        ConsultRecibos(pag, cantRecibos.value, (resp) => {
            setRecibos(resp);
            setPreloader2("")
        })
    }

    let itemsPagInd = () => {
        let items = [];
        for (let i = 1; i <= paginas; i++) {
            items.push(
              <Pagination.Item key={i} active={i === pag} onClick={cambiaPag(i)}>
                {i}
              </Pagination.Item>,
            );
        }
        return items;
    }

    let itemsPag = () => {
        if (paginas > maxPaginas){
            let contenido = []
            for (let i = 1; i <= paginas; i++) {
                contenido.push({
                    value: i, label: `- ${i} -`
                })
            }

            let funcPaginacion = (operacion) => {
                setPagSelect(operacion)
            }

            return(
                <Row style={{paddingBottom:15, paddingTop: 5}}>
                    <Col md={12} align="center" className="text-danger" style={{fontSize: 11}}><strong>PÁGINA</strong></Col>
                    <Col md={5} align="right" style={{paddingTop: 4}}>
                        <button className="btn btn-primary" onClick={() => {
                            if (pagSelect.value === 1) return null;
                            funcPaginacion({ value: (pagSelect.value) - 1, label: `- ${(pagSelect.value) - 1} -` })
                        }} style={{borderWidth: 1}}><i className="fa fa-chevron-left"></i></button>
                    </Col>
                    <Col md={2} align="center">
                        <Select
                            styles={customStyles}
                            isSearchable ={true}
                            value={pagSelect}
                            onChange={cambiaPagSelect}
                            options={contenido}
                        />
                    </Col>
                    <Col md={5} align="left" style={{paddingTop: 4}}>
                        <button className="btn btn-primary" onClick={() => {
                            if (pagSelect.value > paginas) return null;
                            funcPaginacion({ value: (pagSelect.value) + 1, label: `- ${(pagSelect.value) + 1} -` })
                        }} style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
                    </Col>
                </Row>
            )
        }

        return (
            <div align="center">
                <div align="center" className="text-danger" style={{fontSize: 11, marginBottom: 0}}><strong>PÁGINAS</strong></div>
                <div><Pagination bsSize="sm" style={{marginTop:0}}>{itemsPagInd()}</Pagination></div>
            </div>
        )
    }

    let modalReporte = () => {
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<ReciboDePagoList datos ={recibos} pagina = {pagSelect.value}
                cantidad = {cantRecibos.value}
                paginas = {paginas}/>}

                titulo={`Recibos de Pago`}
                display= "block"
                cerrar = {() => {setOpenWR(false)}}
            />
        )
    }

    let contenido = () => (
        <React.Fragment>
            <div className="custom-alert-info">
                Búsqueda de Estudiantes <i className={icon2}></i>
                <input type="text" className="form-control" disabled={disabled} onKeyPress={busquedaEst()} value={string} onChange={(e) => {setString(e.target.value)}} placeholder="Ingresa la C.I., nombre o apellido del estudiante o el N° de la factura"/>
            </div>
            <Row>
                <Col md = {9} className="custom-mt-10">
                    <div className="custom-alert-danger">
                        <Row>
                            <Col md={6} style={{paddingTop: 10,}}>
                                Máximo de recibos a mostrar {preloader2}
                            </Col>
                            <Col md={6}>
                                <Select
                                    styles={customStyles}
                                    isSearchable ={true}
                                    value={cantRecibos}
                                    onChange={cambiaRecibos}
                                    options={Recibos}
                                />
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md = {3} className="custom-mt-10" align="right">
                    <button className="btn btn-relleno-danger" onClick={() => {setOpenWR(true)}} style={{borderWidth: 1}} title="Imprime el listado actual"><i className="fa fa-print"></i> Imprimir</button>
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={12}>
                    {itemsPag()}
                </Col>
                <Col md={12}>
                    <div className="table-responsive" style={{backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped bordered hover style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color" align="center">
                                    <td width="100px" style={styles}><strong>N°</strong></td>
                                    <td width="25%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="45%" style={styles}><strong>Detalles</strong></td>
                                    <td width="100px" style={styles} align="center"><strong>Estatus</strong></td>
                                    <td width="100px" style={styles} align="center"><strong>Factura</strong></td>
                                </tr>
                                {detallesRecibos()}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )

    let ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección puedes revisar los <span className="text-primary"><strong>Recibos de Pago</strong></span> de los estudiantes asi como tambíén crear un reporte para su impresión
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Para ello primero debes ingresar un dato del estudiante que deseas consultar (Cédula, Nombre o Apellido), o puedes imprimir la cantidad de estudiantes que desees desde la opción <strong className="text-danger">Máximo de recibos a mostrar</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Al realizar la consulta podrás ver un listado con las coincidencias.
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Si el número de coincidencias es mayor que el límite seleccionado, verás un paginador al cual puedes seleccionar para cambiar de página
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Cada transacción tiene los siguientes datos:
            </Col>
            <Col md={3} className="custom-mt-10 text-primary">
                <strong style={{fontSize: 12}}>N°</strong>
            </Col>
            <Col md={9} className="custom-mt-10" align="justify">
                Indica el número del recibo (este número es ingresado automáticamente por el sistema)
            </Col>
            <Col md={3} className="custom-mt-10 text-primary">
                <strong style={{fontSize: 12}}>Estudiante</strong>
            </Col>
            <Col md={9} className="custom-mt-10" align="justify">
                Indica el número de cédula y el nombre del estudiante que hizo la transacción
            </Col>
            <Col md={3} className="custom-mt-10 text-primary">
                <strong style={{fontSize: 12}}>Detalles</strong>
            </Col>
            <Col md={9} className="custom-mt-10" align="justify">
                Muestra detalles de la transacción tales como fecha, banco, descripción, monto, método de pago y total a pagar
            </Col>
            <Col md={3} className="custom-mt-10 text-primary">
                <strong style={{fontSize: 12}}>Estatus</strong>
            </Col>
            <Col md={9} className="custom-mt-10" align="justify">
                Muestra el estado actual del recibo de pago:
                <div><i className="fa fa-check-circle text-success"></i> indica que el recibo ya fue preocesado</div>
                <div><i className="fa fa-times-circle text-danger"></i> indica que el recibo aun no ha sido procesado</div>
                <div><button className="btn btn-relleno-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-trash"></i></button> Indica que el estado de cuenta de ese recibo fue eliminado por lo que es inválido</div>
            </Col>
            <Col md={3} className="custom-mt-10 text-primary">
                <strong style={{fontSize: 12}}>Factura</strong>
            </Col>
            <Col md={9} className="custom-mt-10" align="justify">
                Muestra el Número de la factura ingresada por adminsitración
            </Col>
        </Row>
    )

    return (
        <div className="content">
            <Row>
                <Col md={8}>
                    {contenido()}
                </Col>
                <Col md={4}>
                    <div style={{borderRadius: "4px 4px",}}>
                        <CustomCard
                            styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                            title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                            category={<span style={{color: "#fff"}}>Recibos de Pago</span>}
                            color="#a80012"
                            content={ayuda()}
                        />
                    </div>
                </Col>
            </Row>
            {modalReporte()}
        </div>
    );
}
 
export default RecibosDePago;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/RecibosDePago.jsx